module.exports = __webpack_public_path__ + "static/img/8areaB_01.a046c03.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_01.png
// module id = 1230
// module chunks = 1